import type * as ApolloReactHooks from "@apollo/client"
import { gql } from "@apollo/client"

import { WAREHOUSE_LIST_ITEM_FRAGMENT } from "lib/fragments"

import type {
  WarehouseListItemFragment,
  WarehousesQuery,
  WarehousesQueryVariables,
} from "../graphql"
import { useWarehousesQuery } from "../graphql"

void gql`
  query Warehouses($skip: Int, $take: Int, $where: WarehouseWhereInput) {
    findManyWarehouse(
      skip: $skip
      take: $take
      where: $where
      orderBy: { city: asc }
    ) {
      ...WarehouseListItem
    }
  }
  ${WAREHOUSE_LIST_ITEM_FRAGMENT}
`

export function useWarehouses(
  options?: ApolloReactHooks.QueryHookOptions<
    WarehousesQuery,
    WarehousesQueryVariables
  >,
): { warehouses: WarehouseListItemFragment[]; loading: boolean } {
  const { data, loading } = useWarehousesQuery({
    ...options,
    variables: {
      where: {
        isDisabled: {
          equals: false,
        },
      },
    },
  })
  return { warehouses: data?.findManyWarehouse || [], loading }
}
